/**
 * Client Portal Navigation
 * Horizontal nav bar for portal pages
 */

import { NavLink } from 'react-router-dom'
import {
  LayoutDashboard,
  FileText,
  Calendar,
  MessageCircle,
  Receipt,
  Clock
} from 'lucide-react'
import { usePortalUnreadCount } from '../../features/portal/hooks/use-portal-unread-count'
import { PortalMessageBadge } from '../../features/portal/components/portal-message-badge'

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/portal' },
  { icon: FileText, label: 'Documents', path: '/portal/documents' },
  { icon: Calendar, label: 'Filings', path: '/portal/filings' },
  { icon: MessageCircle, label: 'Messages', path: '/portal/messages' },
  { icon: Receipt, label: 'Invoices', path: '/portal/invoices' },
  { icon: Clock, label: 'Appointments', path: '/portal/appointments' },
]

interface ClientPortalNavProps {
  mobileOpen?: boolean
  onClose?: () => void
}

export function ClientPortalNav({ mobileOpen, onClose }: ClientPortalNavProps) {
  const { unreadCount } = usePortalUnreadCount()

  return (
    <nav className={`portal-nav ${mobileOpen ? 'portal-nav--mobile-open' : ''}`}>
      {navItems.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          end={item.path === '/portal'}
          className={({ isActive }) =>
            `portal-nav-link ${isActive ? 'active' : ''}`
          }
          onClick={() => onClose?.()}
        >
          <item.icon size={18} />
          <span style={{ position: 'relative' }}>
            {item.label}
            {item.label === 'Messages' && <PortalMessageBadge count={unreadCount} />}
          </span>
        </NavLink>
      ))}
    </nav>
  )
}
